import {RestRequestGET, RestRequestPOST} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";
import reduxStore from "redux/store";
import {clearResource, setResource, setSaveStatusError} from "redux/actions";

const OFFER_CHOICE_ACTIVE_APPROVAL_RESOURCE_ID = 'offerChoiceActiveApproval';
const OFFER_CHOICE_APPROVAL_HISTORY_LIST_RESOURCE_ID = 'offerChoiceApprovalHistoryList';
const OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID = 'offerChoiceApprovalHistory';

const getActiveApproval = async (demandId) => {
    const res = await RestRequestGET(Endpoints.OFFER_CHOICE_APPROVAL(demandId))
    reduxStore.dispatch(
        setResource(OFFER_CHOICE_ACTIVE_APPROVAL_RESOURCE_ID, res)
    );
}

const startApproval = async (demandId, payload) => {
    const res = await RestRequestPOST(Endpoints.OFFER_CHOICE_APPROVAL(demandId), payload)
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false;
    }
}

const selectApprovers = async (demandId, payload) => {
    const res = await RestRequestPOST(Endpoints.OFFER_CHOICE_APPROVAL_SELECT_APPROVERS(demandId), payload);
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const sendDecision = async (demandId, payload) => {
    const res = await RestRequestPOST(Endpoints.OFFER_CHOICE_APPROVAL_SEND_DECISION(demandId), payload);
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const resetApproval = async (demandId) => {
    const res = await RestRequestPOST(Endpoints.OFFER_CHOICE_APPROVAL_RESET(demandId));;
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const stopApproval = async (demandId) => {
    const res = await RestRequestPOST(Endpoints.OFFER_CHOICE_APPROVAL_STOP(demandId));;
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const getApprovalHistoryList = async (demandId) => {
    const res = await RestRequestGET(Endpoints.OFFER_CHOICE_APPROVAL_HISTORY_LIST(demandId))
    reduxStore.dispatch(
        setResource(OFFER_CHOICE_APPROVAL_HISTORY_LIST_RESOURCE_ID, res.result)
    );
}

const getApprovalHistory = async (demandId, approvalId) => {
    const res = await RestRequestGET(Endpoints.OFFER_CHOICE_APPROVAL_HISTORY(demandId, approvalId));
    const {resources} = reduxStore.getState();
    if (!!resources[OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID]) {
        const approvalHistory = resources[OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID];
        approvalHistory[`${approvalId}`] = res.result;
        // const newApprovalHistory = {};
        // Object.keys(approvalHistory).forEach(k => {
        //     if (k === `${approvalId}`)
        //         newApprovalHistory[k] = res.result;
        //     else
        //         newApprovalHistory[k] = approvalHistory[k];
        // })
        reduxStore.dispatch(
            setResource(OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID, approvalHistory)
        );
    } else {
        const o = {};
        o[`${approvalId}`] = res.result;
        reduxStore.dispatch(
            setResource(OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID, o)
        );
    }
}

const getPositionsForApproval = async (demandId) => {
    const res = await RestRequestGET(Endpoints.OFFER_CHOICE_APPROVAL_POSITIONS_LIST(demandId))
    return res.result;
}

const getAvailableApprovers = async (demandId, approvalId, stageId) => {
    const res = await RestRequestGET(Endpoints.OFFER_CHOICE_APPROVAL_HISTORY_GET_APPROVERS(demandId, approvalId, stageId));
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return null;
    }
}

const addApprovers = async (demandId, approvalId, stageId, approverIds) => {
    const res = await RestRequestPOST(Endpoints.OFFER_CHOICE_APPROVAL_HISTORY_ADD_APPROVERS(demandId, approvalId, stageId), {approvers: approverIds});
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false;
    }
}

const deleteApprover = async (demandId, approval, stage, approver) => {
    const res = await RestRequestPOST(Endpoints.OFFER_CHOICE_APPROVAL_HISTORY_DELETE_APPROVER(demandId, approval.identity, stage.identity), {approvers: [approver.identity]});
    if (res.success) {
        approval.stages = approval.stages.map(s => {
            if (s.identity === stage.identity) {
                return {
                    ...s,
                    approvers: s.approvers.filter(a => a.identity !== approver.identity)
                }
            } else {
                return s;
            }
        });
        const {resources} = reduxStore.getState();
        const approvalHistory = resources[OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID];
        approvalHistory[`${approval.identity}`] = approval;
        reduxStore.dispatch(
            setResource(OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID, approvalHistory)
        );
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false;
    }
}

const validate = async (demandId) => {
    return RestRequestGET(Endpoints.OFFER_CHOICE_APPROVAL_VALIDATE(demandId));
}

const clearResources = (resId) => reduxStore.dispatch(clearResource(resId));

export default {
    getActiveApproval,
    startApproval,
    selectApprovers,
    sendDecision,
    resetApproval,
    stopApproval,
    getApprovalHistoryList,
    getApprovalHistory,
    getPositionsForApproval,
    getAvailableApprovers,
    addApprovers,
    deleteApprover,
    validate,
    clearResources,
    OFFER_CHOICE_ACTIVE_APPROVAL_RESOURCE_ID,
    OFFER_CHOICE_APPROVAL_HISTORY_LIST_RESOURCE_ID,
    OFFER_CHOICE_APPROVAL_HISTORY_RESOURCE_ID
}